import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Button, Nav, NavItem, NavLink, TabContent, TabPane, Row } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import renderSelectField from '../../../../shared/components/form/Select';
import { withTranslation } from 'react-i18next';
import ProfileImage from './ProfileImage';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import classnames from 'classnames';
import FormConfigEmail from './FormConfigEmail';
import SMSConfig from './SMSConfig';
import VisualOptions from './VisualOptions';
import Workplaces from './Workplaces';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

const fiscalRegimeOptions = [
    { value: 1, label: 'REGIMEN SIMPLIFICADO (NO RESPONSABLE DE IVA', id: 1 },
    { value: 2, label: 'REGIMEN COMÚN', id: 2 },
    { value: 3, label: 'REGIMEN ESPECIAL', id: 3 }
]

const tributaryResponsability = [
    { value: 1, label: 'IVA', id: 1 },
    { value: 2, label: 'INC', id: 2 },
    { value: 3, label: 'IVA e INC', id: 3 },
    { value: 4, label: 'No Aplica', id: 4 }
]

const taxpayerType = [
    { value: 1, label: 'PERSONA NATURAL', id: 1 },
    { value: 2, label: 'PERSONA JURIDICA', id: 2 }
]

const responsabilityType = [
    { value: 1, label: 'O-13 - GRAN CONTRIBUYENTE', id: 1 },
    { value: 2, label: 'O-15 - AUTORRETENEDOR', id: 2 },
    { value: 3, label: 'O-23 - AGENTE DE RETENCIÓN IVA', id: 3 },
    { value: 4, label: 'O-47 - RÉGIMEN SIMPLE DE TRIBUTACIÓN', id: 4 },
    { value: 5, label: 'R-99-PN - NO RESPONSABLE (NO RESPONSABLE DE IVA)', id: 5 },
]


class FormProfile extends Component {
    constructor() {
        super();
        this.state = {
            nit: '',
            name: '',
            country: '',
            department: '',
            city: '',
            telephone1: '',
            telephone2: '',
            email: '',
            postal: '',
            code: '',
            type: '',
            type_option: '',
            errors: {},
            departments: [],
            countries: [],
            idClinica: '',
            cities: [],
            loadData: false,
            loadCities: false,
            imagenActual: null,
            activeTab: '1',
            SMSEnabled: false,
            fiscalRegime: null,
            responsabilityType: null,
            tributaryResponsability: null,
            taxpayerType: null,
            configWorkplaces: false,
            workplaces: []

        }
       
    }

    toggle = (tab) => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    componentDidMount() {
        this.loadWorkplaces();
        this.loadDepartment().then((departments) => {
            this.setState({ departments: departments }, () => {
                this.loadDataProfile().then((profile) => {
                    this.loadCountries().then((countries) => {
                        this.setState({countries: countries})
                    });
                    
                        this.setState({ department: { value: this.state.departments.filter((department) => { return department.id === profile[0].direccion.id_dpto })[0].depcod, label: this.state.departments.filter((department) => { return department.id === profile[0].direccion.id_dpto })[0].depnom, id: this.state.departments.filter((department) => { return department.id === profile[0].direccion.id_dpto })[0].id } }, () => {
                            this.loadCities(this.state.department.value).then((cities) => {
                                this.setState({
                                    nit: profile[0].nit,
                                    name: profile[0].nombre,
                                    city: { value: cities.filter((city) => { return city.id === profile[0].direccion.id_ciudad })[0].ciucod, label: cities.filter((city) => { return city.id === profile[0].direccion.id_ciudad })[0].ciunom, id: cities.filter((city) => { return city.id === profile[0].direccion.id_ciudad })[0].id },
                                    country: { value: profile[0].direccion.id_pais, id: profile[0].direccion.id_pais, label: this.state.countries.filter((country) => { return country.id == profile[0].direccion.id_pais })[0]?.painom },
                                    address: profile[0].direccion.direccion,
                                    email: profile[0].email,
                                    telephone1: profile[0].telefono1,
                                    telephone2: profile[0].telefono2,
                                    postal: profile[0].codigo_postal,
                                    code: profile[0].cod_act_econ,
                                    idClinica: profile[0].id_clinica,
                                    type: profile[0].tipo,
                                    imagenActual: profile[0].imagen,
                                    loadData: true,
                                    SMSEnabled: profile[0].enable_sms,
                                    fiscalRegime: fiscalRegimeOptions.find(fro => fro.value == profile[0].regimen_fiscal),
                                    responsabilityType: responsabilityType.find(fro => fro.value == profile[0].tipo_responsabilidad),
                                    tributaryResponsability: tributaryResponsability.find(fro => fro.value == profile[0].responsabilidad_tributaria),
                                    taxpayerType: taxpayerType.find(fro => fro.value == profile[0].tipo_contribuyente)
                                }, () => {
                                    const { dispatch } = this.props;
                                    dispatch(change('profile_ips_form', 'name', this.state.name));
                                    dispatch(change('profile_ips_form', 'select_country', this.state.country));
                                    dispatch(change('profile_ips_form', 'select_department', this.state.department));
                                    dispatch(change('profile_ips_form', 'select_city', this.state.city));
                                    dispatch(change('profile_ips_form', 'email', this.state.email));
                                    dispatch(change('profile_ips_form', 'telephone-1', this.state.telephone1));
                                    dispatch(change('profile_ips_form', 'telephone-2', this.state.telephone2));
                                    dispatch(change('profile_ips_form', 'postal-code', this.state.postal));
                                    dispatch(change('profile_ips_form', 'code', this.state.code));
                                    dispatch(change('profile_ips_form', 'dirección', this.state.address));
                                    dispatch(change('profile_ips_form', 'select_type', this.state.type));
                                    dispatch(change('profile_ips_form', 'select_fiscal_regime', this.state.fiscalRegime));
                                    dispatch(change('profile_ips_form', 'select_fiscal_type_responsability', this.state.responsabilityType));
                                    dispatch(change('profile_ips_form', 'select_tributary-responsability', this.state.tributaryResponsability));
                                    dispatch(change('profile_ips_form', 'select_taxpayer_type', this.state.taxpayerType));
                                });
                            })
                        })
                

                }).catch((error) => {
                    console.log(error);
                });
            });
        }).catch((error) => {
            console.log(error);
        });

    }


    loadDataProfile = () => {

        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.length > 0) {
                        console.log("DATAPROFILE", data)
                        resolve(data);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        });

    }

    maskNIT = (valor) => {
        var cadena = "";
        if (valor.match(/^(([0-9]|(-{1})){0,11})$/) && valor.length <= 11) {
            cadena = valor;
        } else if (valor.length > 11) {
            cadena = this.state.nit;
        } else {
            cadena = this.state.nit;
        }

        return cadena;
    }

    handleNit = (value) => {
        //var nit = this.maskNIT(value);
        this.setState({ nit: value });
    }

    handleName = (value) => {
        this.setState({ name: value });

    }

    handleCountry = (e) => {
        this.setState({ country: e, department:{}, city:{}, cities:[] }, ()=>{
            const { dispatch } = this.props;
            dispatch(change('profile_ips_form', 'select_department', ''));
            dispatch(change('profile_ips_form', 'select_city', ''));
            this.loadDepartment(e.value).then((departamentos)=>{this.setState({departments: departamentos})});
        });
    }

    handleDepartment = (e) => {
        this.setState({ department: e, city: {} }, () => {
            const { dispatch } = this.props;
            dispatch(change('profile_ips_form', 'select_city', ''));
            this.loadCities(e.value);
        });
    }

    handleCity = (e) => {
        this.setState({ city: e });
    }

    handleEmail = (value) => {
        this.setState({ email: value });
    }

    handlerAddress = (value) => {
        this.setState({ address: value });
    }

    handlerTelephone1 = (value) => {
        this.setState({ telephone1: value });
    }

    handlerTelephone2 = (value) => {
        this.setState({ telephone2: value });
    }

    handlerPostal = (value) => {
        this.setState({ postal: value });
    }

    handlerCode = (value) => {
        this.setState({ code: value });
    }

    handlerChangeSMSConfig = (enable) => {
        this.setState({ SMSEnabled: enable });
    }

    handleFiscalRegime = (value) => {
        this.setState({ fiscalRegime: value })
    }

    handleResponsabilityType = (value) => {
        this.setState({ responsabilityType: value })
    }

    handleTributaryResponsability = (value) => {
        this.setState({ tributaryResponsability: value });
    }

    handleTaxpayerType = (value) => {
        this.setState({ taxpayerType: value });
    }

    loadDepartment = (paicod) => {
        return new Promise((resolve, reject) => {
            const getURL = paicod? `departamentos/listar?id_pais=${paicod}` : `departamentos/listar`
            fetch(process.env.REACT_APP_PUBLIC_URL + getURL , {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })

    }

    loadCountries = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'paises/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    loadCities = (depcod) => {
        var data = { id_dpto: depcod };
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/listar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data);
                    this.setState({ cities: data });
                    //console.log(data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                    resolve(error);
                });
        })
    }

    departmentsOption = () => {
        if (this.state.departments.length > 0) {
            return this.state.departments.map((department) => {
                return { value: department.depcod, label: department.depnom, id: department.id }
            });
        }
    }


    countriesOptions = () => {
        if(this.state.countries.length > 0){
            return this.state.countries.map((country) => {
                return { value: country.id, label: country.painom, id: country.id }
            });
        }
    }

    citiesOptions = () => {
        return this.state.cities.map((city) => {
            return { value: city.ciucod, label: city.ciunom, id: city.id }
        });
    }

    isCheckOK = (nit) => {

        let cant = nit.length;

        if (nit[(cant - 2)] !== '-') {
            return false;
        } else if (isNaN(nit[cant - 1]) || isNaN(nit.substring(0, cant - 3))) {
            return false;
        } else {
            return true;
        }
    }

    /*else if (nit.length !== 11) {
                return false;
            }  */
    validate = () => {
        var errors = {};
        if (!this.state.nit) {
            errors.nit = 'El campo de nit no debe estar vacio';
        } else if (!this.isCheckOK(this.state.nit)) {
            errors.nit = "Este Valor no corresponde a un NIT valido";
        } else {
            delete errors.nit;
        }

        if (!this.state.name) {
            errors.name = 'El campo de nombre no debe estar vacio';
        } else {
            delete errors.name;
        }

        if (!this.state.country) {
            errors.country = 'seleccione un país';
        } else {
            delete errors.country;
        }

        if (!this.state.department) {
            errors.department = 'seleccione un departamento';
        } else {
            delete errors.department;
        }

        if (!this.state.city) {
            errors.city = 'seleccione un ciudad';
        } else {
            delete errors.city;
        }

        if (!this.state.address) {
            errors.address = 'Ingrese una dirección';
        } else {
            delete errors.address;
        }

        if (!this.state.email) {
            errors.email = 'Ingrese un e-mail';
        } else {
            delete errors.email;
        }

        if (!this.state.telephone1) {
            errors.telephone1 = 'Ingrese el telefono uno';
        } else {
            delete errors.telephone1;
        }

        if (!this.state.code) {
            errors.code = 'ingrese un código';
        } else {
            delete errors.code;
        }
        if (!this.state.type) {
            errors.type = 'ingrese un tipo';
        } else {
            delete errors.type;
        }
        // fiscalRegime tributaryResponsability responsabilityType taxpayerType
        if (!this.state.fiscalRegime) {
            errors.fiscalRegime = 'ingrese un Regimen Fiscal';
        } else {
            delete errors.fiscalRegime;
        }
        if (!this.state.tributaryResponsability) {
            errors.tributaryResponsability = 'ingrese la Responsabilidad Tributaria';
        } else {
            delete errors.tributaryResponsability;
        }
        if (!this.state.responsabilityType) {
            errors.responsabilityType = 'ingrese el Tipo Responsabilidad';
        } else {
            delete errors.responsabilityType;
        }
        if (!this.state.taxpayerType) {
            errors.taxpayerType = 'ingrese el Tipo de Contribuyente';
        } else {
            delete errors.taxpayerType;
        }
        this.setState({ errors: errors });
        if (Object.keys(errors).length > 0) {
            return true;
        } else {
            return false;
        }
    }

    createProfile = () => {
        if (!this.validate()) {
            var data = {
                nit: this.state.nit,
                nombre: this.state.name,
                direccion:
                {
                    id_pais: this.state.country.id,
                    id_dpto: this.state.department.id,
                    id_ciudad: this.state.city.id,
                    ciucod: this.state.city.value,
                    direccion: this.state.address,
                    depcod: this.state.department.value
                },
                cod_act_eco: this.state.code,
                telefono1: this.state.telephone1,
                telefono2: this.state.telephone2,
                correo: this.state.email,
                codigo_postal: this.state.postal,
                tipo: this.state.type
            };

            console.log(data);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    return response.text();
                })
                .then(data => {
                    alert(data);
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    updateProfile = () => {
        if (!this.validate()) {
            var data = {
                id_clinica: this.state.idClinica,
                nit: this.state.nit,
                nombre: this.state.name,
                direccion:
                {
                    id_pais: this.state.country.id,
                    id_dpto: this.state.department.id,
                    id_ciudad: this.state.city.id,
                    direccion: this.state.address,
                    ciucod: this.state.city.value,
                    depcod: this.state.department.value
                },
                cod_act_eco: this.state.code,
                telefono1: this.state.telephone1,
                telefono2: this.state.telephone2,
                correo: this.state.email,
                codigo_postal: this.state.postal,
                tipo: this.state.type,
                id_sede: 1,
                tipo_responsabilidad: this.state.responsabilityType.value,
                responsabilidad_tributaria: this.state.tributaryResponsability.value,
                tipo_contribuyente: this.state.taxpayerType.value,
                regimen_fiscal: this.state.fiscalRegime.value
            };
            console.log(data);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error("Ha ocurrido un error en el servidor");
                    }
                })
                .then(data => {
                    alert("Perfil actualizado correctamente");
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    loadWorkplaces = async () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'sedes/listar', {
               method: 'GET',
               headers: {
                   'Content-Type': 'application/json',
                   'authorization': 'Bearer ' + sessionStorage.getItem('token'),
               }
            })
            .then((response) => {
                return response.json();
            })
            .then(data => {
                resolve(data)
                this.setState({ workplaces: data });
            })
            .catch((error) => {
                console.error('Error:', error);
                reject(error);
            });
        })
    }

    render() {

        const { activeTab } = this.state;

        return (<Col md={12} lg={12}>
            <Card>
                <CardBody>

                    <div className="tabs tabs--bordered-top">
                        <div className="tabs__wrap">
                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '1' })}
                                        onClick={() => {
                                            this.toggle('1');
                                        }}
                                    >
                                        Institución
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '2' })}
                                        onClick={() => {
                                            this.toggle('2');
                                        }}
                                    >
                                        Correo Electronico
                                    </NavLink>
                                </NavItem>
                                {
                                    JSON.parse(sessionStorage.getItem('usuario')).id_perfil == 9 ?
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '3' })}
                                                onClick={() => {
                                                    this.toggle('3');
                                                }}
                                            >
                                                Mensajes de Texto
                                            </NavLink>
                                        </NavItem> : null
                                }
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === '4' })}
                                        onClick={() => {
                                            this.toggle('4');
                                        }}
                                    >
                                        Visualizadores
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <div className="form">
                                        <div className="form__half" style={{ marginRight: 30 }}>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">NIT</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                                        <input
                                                            placeholder="123456789-1"
                                                            value={this.state.nit}
                                                            type="text"
                                                            onChange={(e) => this.handleNit(e.target.value)}
                                                        />
                                                        {this.state.errors.nit !== '' && this.state.errors.nit && <span className="form__form-group-error">{this.state.errors.nit}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">País</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_country"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.country}
                                                        meta={{ touched: this.state.errors.country != '', error: this.state.errors.country }}
                                                        onChange={(e) => {
                                                            this.handleCountry(e);
                                                        }}
                                                        options={this.countriesOptions()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Nombre de la Empresa</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="name"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.name}
                                                        meta={{ touched: this.state.errors.name !== '', error: this.state.errors.name }}
                                                        onChange={(e) => this.handleName(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Departamento</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_department"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.department}
                                                        meta={{ touched: this.state.errors.department !== '', error: this.state.errors.department }}
                                                        onChange={(e) => {
                                                            this.handleDepartment(e);
                                                        }}
                                                        options={this.departmentsOption()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half" style={{ marginRight: 30 }}>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Ciudad</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_city"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.city}
                                                        meta={{ touched: this.state.errors.city !== '', error: this.state.errors.city }}
                                                        onChange={(e) => {
                                                            this.handleCity(e);
                                                        }}
                                                        options={this.citiesOptions()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">E-mail</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="email"
                                                        component={renderField}
                                                        type="email"
                                                        value={this.state.email}
                                                        meta={{ touched: this.state.errors.email !== '', error: this.state.errors.email }}
                                                        onChange={(e) => this.handleEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half">
                                            <div className="form__form-group" style={{ height: '70.8px' }}>
                                                <span className="form__form-group-label">Dirección</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="dirección"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.address}
                                                        meta={{ touched: this.state.errors.address !== '', error: this.state.errors.address }}
                                                        onChange={(e) => this.handlerAddress(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Telefono 1</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="telephone-1"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.telephone1}
                                                        meta={{ touched: this.state.errors.telephone1 !== '', error: this.state.errors.telephone1 }}
                                                        onChange={(e) => this.handlerTelephone1(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half" style={{ marginRight: 30 }}>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Codigo postal</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="postal-code"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.postal}
                                                        meta={{ touched: this.state.errors.postal !== '', error: this.state.errors.postal }}
                                                        onChange={(e) => this.handlerPostal(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Codigo</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="code"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.postal}
                                                        meta={{ touched: this.state.errors.code !== '', error: this.state.errors.code }}
                                                        onChange={(e) => this.handlerCode(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Telefono 2</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="telephone-2"
                                                        component={renderField}
                                                        type="text"
                                                        value={this.state.telephone2}
                                                        meta={{ touched: this.state.errors.telephone2 !== '', error: this.state.errors.telephone2 }}
                                                        onChange={(e) => this.handlerTelephone2(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Tipo</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_type"
                                                        component={renderMultiSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.type}
                                                        //meta={{ touched: this.state.errors.type != '', error: this.state.errors.type }}
                                                        onChange={(e) => {
                                                            this.setState({ type: e });
                                                        }}

                                                        options={[
                                                            { value: '1', label: 'IPS' },
                                                            { value: '2', label: 'Centros de Investigacion' },
                                                            { value: '3', label: 'Medicina Nuclear' },
                                                            { value: '4', label: 'Fonoaudiología' },
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__half" style={{ marginRight: 30 }}>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Regimen Fiscal</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_fiscal_regime"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.fiscalRegime}
                                                        meta={{ touched: this.state.errors.fiscalRegime != '', error: this.state.errors.fiscalRegime }}
                                                        onChange={(e) => {
                                                            this.handleFiscalRegime(e);
                                                        }}
                                                        options={fiscalRegimeOptions}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Responsabilidad Tributaria</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_tributary-responsability"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.tributaryResponsability}
                                                        meta={{ touched: this.state.errors.tributaryResponsability != '', error: this.state.errors.tributaryResponsability }}
                                                        onChange={(e) => {
                                                            this.handleTributaryResponsability(e);
                                                        }}
                                                        options={tributaryResponsability}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__half">
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Tipo de Responsabilidad</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_fiscal_type_responsability"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.responsabilityType}
                                                        meta={{ touched: this.state.errors.responsabilityType != '', error: this.state.errors.responsabilityType }}
                                                        onChange={(e) => {
                                                            this.handleResponsabilityType(e);
                                                        }}
                                                        options={responsabilityType}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Tipo de Contribuyente</span>
                                                <div className="form__form-group-field">
                                                    <Field
                                                        name="select_taxpayer_type"
                                                        component={renderSelectField}
                                                        className="form__form-group-input-wrap--error-above"
                                                        value={this.state.taxpayerType}
                                                        meta={{ touched: this.state.errors.taxpayerType != '', error: this.state.errors.taxpayerType }}
                                                        onChange={(e) => {
                                                            this.handleTaxpayerType(e);
                                                        }}
                                                        options={taxpayerType}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {this.state.loadData ?
                                            <Fragment>
                                                <div className='flex-end-elem-alg-center'>
                                                    <Button
                                                        style={{ marginTop: 20 }}
                                                        color="primary"
                                                        onClick={() => {
                                                            this.updateProfile();
                                                        }}
                                                    >
                                                        Actualizar Perfil
                                                    </Button>
                                                </div>
                                            </Fragment>
                                            :
                                            <Button
                                                style={{ marginTop: 20 }}
                                                color="primary"
                                                onClick={() => {
                                                    this.createProfile();
                                                }}
                                            >
                                                Crear Perfil
                                            </Button>}
                                    </div>
                                    <hr />
                                    <Row>
                                        <Col md={6}>
                                            <Workplaces workplaces={this.state.workplaces} loadWorkplaces={this.loadWorkplaces} />
                                        </Col>
                                        <Col md={6}>
                                            <ProfileImage imagenActual={this.state.imagenActual} idClinica={this.state.idClinica} />
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2">
                                    <FormConfigEmail />
                                </TabPane>

                                {
                                    JSON.parse(sessionStorage.getItem('usuario')).id_perfil == 9 ?
                                        <TabPane tabId="3">
                                            <SMSConfig SMSEnabled={this.state.SMSEnabled} handlerChangeSMSConfig={this.handlerChangeSMSConfig} />
                                        </TabPane> : null
                                }

                                <TabPane tabId="4">
                                    {this.state.idClinica != null && this.state.idClinica != undefined && this.state.idClinica != '' ?
                                        <VisualOptions /> : null}
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>)
    }
}

export default reduxForm({
    form: 'profile_ips_form', // a unique identifier for this form
})(withTranslation('common')(FormProfile));